import type { SkillProposalSource } from '../../apps/apis/claudeCodeDashboard/types';
import { SKILL_PROPOSAL_SOURCE_HELP } from './agentTelemetryHelp';
import { HelpBadge } from './HelpTooltip';

interface Props {
  source?: SkillProposalSource | undefined;
}

const sourceLabel = (source: SkillProposalSource | undefined) => {
  switch (source) {
    case 'local_submission':
      return 'Employee local';
    case 'telemetry_batch':
    default:
      return 'Telemetry batch';
  }
};

const sourceVariant = (source: SkillProposalSource | undefined) =>
  source === 'local_submission' ? 'info' : 'secondary';

const sourceDescription = (source: SkillProposalSource | undefined) =>
  SKILL_PROPOSAL_SOURCE_HELP[source ?? 'telemetry_batch'];

const SkillProposalSourceBadge = ({ source }: Props) => (
  <HelpBadge bg={sourceVariant(source)} description={sourceDescription(source)}>
    {sourceLabel(source)}
  </HelpBadge>
);

export default SkillProposalSourceBadge;
